<header>
  <div class="container">
    <div class="wrapper">
      <div class="logo_wrapper">
        <a routerLink="/" routerLinkActive="active-link" ariaCurrentWhenActive="page">
          <img [src]="theme.getTheme().logoPath + 'main_logo.svg'" alt="cheaptickets.in" class="img-fluid">
        </a>
      </div>
      <div class="nav_wrapper d-none">
        <nav>
          @for (navItem of mainNav; track navItem.path) {
            @if(!navItem.isDisabled) {
              <a class="button" [routerLink]="navItem.path" routerLinkActive="active-link" ariaCurrentWhenActive="page" [class.disabled]="navItem.isDisabled">
                <div class="nav_inner">
                  <div class="linkIcon">
                    <img [src]="theme.getTheme().svgGlobal + navItem.icon" [alt]="navItem.title || 'Navigation icon'" class="img-fluid">
                  </div>
                  <div class="linkText">
                    {{navItem.title}}
                  </div>
                </div>
              </a> 
            }
          }
        </nav>
      </div>
      <div class="space"></div>
      <div class="inner_wrapper d-flex justify-content-between align-items-center">
        <!-- @if(currency && util.isHomeOrFlightPage()) {
          <div class="hraderSupport currency_info currencyMenu">
            <mat-accordion matButton [matMenuTriggerFor]="currencyMenu" color="primary">
              <span class="d-flex pointer">&nbsp;&nbsp;{{ currencySelected?.shortname }}&nbsp;&nbsp;({{ currencySelected?.symbol }})
                <mat-icon fontIcon="expand_more">expand_more</mat-icon>
              </span>
            </mat-accordion>
            <mat-menu #currencyMenu Position="before" color="primary" class="currency_menu">
              @for (item of currency; track $index) {
                <button mat-menu-item (click)="select(item)">
                  <mat-icon color="primary">{{ item?.symbol }}</mat-icon>
                  <span>{{ item?.name | titlecase }} ({{ item?.shortname }})</span>
                </button>
              }
            </mat-menu>
          </div>
          &nbsp;&nbsp;
        } -->
        @if(WEBSITE_INFO !== undefined) {
          <div class="contact_info">
            <mat-accordion matButton [matMenuTriggerFor]="contact_menu" color="primary" class="d-flex">Support  <mat-icon fontIcon="expand_more">expand_more</mat-icon></mat-accordion>
            <mat-menu #contact_menu Position="before" color="primary" class="contact_menu">
              @if(WEBSITE_INFO?.address?.Email) {
                <a mat-menu-item class="matMenuItemContact" href="mailto:{{WEBSITE_INFO?.address?.Email}}">
                  <mat-icon color="primary" fontIcon="email"></mat-icon>
                  <span>{{WEBSITE_INFO?.address?.Email}}</span>
                </a>
              }
              @if(WEBSITE_INFO?.address?.CustomerSupport_phone) {
                <a mat-menu-item class="matMenuItemContact" [href]="'tel:' + WEBSITE_INFO?.address?.CustomerSupport_phone">
                  <mat-icon color="primary" fontIcon="call"></mat-icon>
                  <span>{{WEBSITE_INFO?.address?.CustomerSupport_phone}}</span> <!-- | removeParentheses-->
                </a>
              }
              @if(WEBSITE_INFO?.address?.CustomerSupport){
                <a mat-menu-item class="teleicon matMenuItemContact" [href]="'tel:' + WEBSITE_INFO?.address?.CustomerSupport">
                  <mat-icon color="primary" fontIcon="support_agent"></mat-icon>
                  <span>{{WEBSITE_INFO?.address?.CustomerSupport }}</span> <!--| removeParentheses-->
                </a>
              }
            </mat-menu>
          </div>
          &nbsp;&nbsp;
        }
        <!-- Login Button User Profile -->
         @if(!(authState.isLoggedIn$ | async) && util.isHomeOrFlightPage()) {
            <button matButton="outlined" class="outline_button" (click)="authSetting()">Sign In/Log In</button>
          }
          @if(authState.isLoggedIn$ | async) {
            <div class="login_profile">
              <div class="update_profile" matButton [matMenuTriggerFor]="user_profile">
                <div class="user_img">
                  @if ((authState.user$ | async)?.profile_img && !imageError) {
                    <img [src]="((authState.user$ | async)?.profile_img) | brokenImageUrl" alt="user" (error)="handleImageError()">
                  } @else {
                    {{ userInitials() }}
                  }
                </div>
                <div class="userInfo">
                  <h4 class="name">Hi, {{(authState.user$ | async)?.name}}</h4>
                  <p>Welcome to {{theme.getTheme().siteName}}<br>your ultimate travel companion!</p>
                </div>
              </div>
              <mat-menu #user_profile Position="after" color="primary" class="profile_navation">
                @for (item of authProfile; track $index) {
                  <a mat-menu-item class="profileNav matMenuItemContact" [routerLink]="item.path">
                    <mat-icon color="primary" class="iconColor" [fontIcon]="item.icon"></mat-icon>
                    <div class="infoNav">
                      <h4>{{item.title}}</h4>
                      <p>{{item.info}}</p>
                    </div>
                  </a>
                }
                <button mat-menu-item (click)="logout()"><mat-icon color="primary" class="iconColor" fontIcon="logout"></mat-icon> Logout</button>
              </mat-menu>
            </div>
          }
      </div>

      <!-- Mobile icon for landscape / small screens -->
      <button type="button" class="mobile_menu" aria-label="Open menu" (click)="toggleSidebar.emit()">
        <mat-icon fontIcon="menu"></mat-icon>
      </button>
    </div>
  </div>
</header>